import { HttpClient, HttpEvent, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class FaqService {
  private url = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}
  getFaqs() {
    return this.http.get<any>(this.url + "/admin/faq/");
  }
  getFaqDetail(id) {
    return this.http.get<any>(this.url + "/admin/faq/getByid?_id=" + id);
  }
  upload(body): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post<any>(this.url + "/admin/faq/", body, {
      responseType: "json",
      headers,
      withCredentials: false,
    });
  }
  update(body): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    return this.http.post<any>(this.url + "/admin/faq/update", body, {
      responseType: "json",
      headers,
      withCredentials: false,
    });
  }
  delete(id): any {
    return this.http.delete(this.url + "/admin/faq/" + id);
  }
}
